<template>
  <div>
    <div class="game-info">
      <div class="banner banner-small">
        <div class="cover">
          <img :src="currentGameCover" />
          <div class="name">
            {{ currentGame.name }}
          </div>
        </div>
        <div class="handle">
          <div class="btn-gray" @click="$router.push('/skill-list')">{{$t('upgrade_page_layout_nav_50')}}</div>
        </div>
      </div>
    </div>

    <div class="select-wrap playerlist-mobile-select">
      <!-- 快捷篩選 -->
      <div ref="filterExt" class="filter-quick" style="width:auto">
        <ul>
          <li
            v-for="item in quickSelectors"
            :key="item.label"
          >
            <fps-checkbox v-model="item.checkbox" :forceMobile="true" @change="quickSelect(item)">
              {{ item.label }}
            </fps-checkbox>
          </li>
        </ul>
      </div>
      <!-- 排序 only web -->
      <el-select v-if="!isMobile" v-model="filterSort" @change="handleSubmit">
        <el-option
          v-for="item in sortOpts"
          :label="item.text"
          :value="item.value"
          :key="item.value"
        >{{ item.text }}</el-option>
      </el-select>
      <el-popover
        v-model="popoverOther"
        placement="bottom-start"
        :width="isMobile ? '100%' : '375'"
        :popper-class="`filter-other-popover ${ isMobile ? 'playerlist-mobile-popover' : '' }`"
        trigger="click">
        <div class="filter-box">
          <template v-if="currentGame.gameSubtypeList && currentGame.gameSubtypeList.length">
            <div class="title">{{$t('upgrade_page_views_player_list_index_174')}}</div>
            <ul>
              <li
                v-for="item in currentGame.gameSubtypeList"
                :key="item.id"
                :class="{ 'active': otherChoices.gameSubTypeId === item.id }"
                @click="selectOthers('gameSubTypeId', item.id)"
              >{{ item.name }}</li>
            </ul>
          </template>
          <template>
            <div class="title">{{$t('upgrade_page_views_player_list_index_175')}}</div>
            <ul>
              <li
                v-for="item in sexOpts"
                :key="item.value"
                :class="{ 'active': filterSex==item.value }"
                @click="selectSex(item.value)"
              >
                {{ item.text }}
              </li>
            </ul>
          </template>
          <div class="title">{{$t('upgrade_page_views_player_list_index_176')}}</div>
          <ul>
            <li
              v-for="item in sortedTagsFront"
              :key="item.id"
              :class="{ 'active': filterTag.includes(item.id) }"
              @click="selectOthers('labels', item.id)"
            >{{ item.label }}</li>
            <li
              v-for="item in filterDiscount"
              :key="item.value"
              :class="{ 'active': otherChoices.discount === item.value }"
              @click="selectOthers('discount', item.value)"
              >{{ item.label }}</li>
            <li
              :class="{ 'active': otherChoices.faceSuccess === true }"
              @click="selectOthers('faceSuccess', true)"
              >{{$t('upgrade_page_views_player_list_index_177')}}</li>
            <li
              v-for="item in sortedTagsEnd"
              :key="item.id"
              :class="{ 'active': filterTag.includes(item.id) }"
              @click="selectOthers('labels', item.id)"
            >{{ item.label }}</li>
          </ul>
          <template v-if="gameLevels.length">
            <div class="title">{{$t('upgrade_page_views_player_list_index_178')}}</div>
            <ul>
              <li
                v-for="item in gameLevels.slice(1)"
                :key="item.gameLevel"
                :class="{ 'active': otherChoices.gameLevelList.includes(item.gameLevel) }"
                @click="selectOthers('gameLevelList', item.gameLevel)"
              >{{ item.gameLevelString }}</li>
            </ul>
          </template>
          <template v-if="goodPosition.length">
            <div class="title">{{$t('upgrade_page_views_player_list_index_179')}}</div>
            <ul>
              <li
                v-for="(item, index) in goodPosition"
                :key="item"
                :class="{ 'active': otherChoices.positions.includes(index) }"
                @click="selectOthers('positions', index)"
              >{{ item }}</li>
            </ul>
          </template>
          <template>
            <div class="title">{{$t('upgrade_page_views_player_list_index_180')}}</div>
            <ul>
              <li
                v-for="item in priceOpts.slice(1)"
                :key="item.value"
                :class="{ 'active': otherChoices.salesPrice === item.value }"
                @click="selectOthers('salesPrice', item.value)"
              >{{ item.text }}</li>
            </ul>
          </template>
        </div>
        <div class="buttons">
          <div class="reset" @click="handleReset">{{$t('upgrade_page_views_player_list_index_181')}}</div>
          <div class="submit" @click="handleSubmit">{{$t('upgrade_page_views_player_list_index_182')}}</div>
        </div>
        <div
          slot="reference"
          class="select-other"
          :class="{
            'active': popoverOther,
            'high-light': otherHighlight,
          }"
        >
          <span>{{$t('upgrade_page_views_player_list_index_183')}}</span>
          <div class="suffix">
            <i class="el-icon-arrow-up"></i>
          </div>
        </div>
      </el-popover>
    </div>

    <div class="list-wrap" :class="{ 'popover-wrap': popoverSome }" ref="listWrap">
      <div v-for="item in list" :key="item.id" ref="playerBox">
        <player-item v-if="item.id > 0" :item="item" :filter-tag="filterTag" />
      </div>
      <div class="loading" v-loading="loading" element-loading-background="inherit" 
      style="width:100%;margin-top:50px"></div>
      <div class="popover" @click="closePopover"></div>
    </div>
    <div v-show="!list.length && !loading" class="empty" :class="{ 'popover-wrap': popoverSome }">
      <img src="~@/assets/image/background/empty-search.png" />
      <p>{{$t('upgrade_page_views_player_list_index_184')}}</p>
      <div class="popover" @click="closePopover"></div>
    </div>
  </div>
</template>

<script>
import i18n from '../../../locales/index'

import { mapGetters, mapActions } from 'vuex'
import PlayerItem from './player-item'

export default {
  components: {
    PlayerItem
  },
  data() {
    const isMobile = window.innerWidth < 600
    const sortOpts = [
      { text: i18n.t('upgrade_page_views_player_list_index_185'), value: 0 },
      { text: i18n.t('upgrade_page_views_player_list_index_186'), value: 1 },
      { text: i18n.t('upgrade_page_views_player_list_index_187'), value: 2 },
      { text: i18n.t('upgrade_page_views_player_list_index_188'), value: 3 },
      { text: i18n.t('upgrade_page_views_player_list_index_189'), value: 4 },
    ]
    const sexOpts = [
      { text: i18n.t('upgrade_page_views_player_list_index_190'), value: 2 },
      { text: i18n.t('upgrade_page_views_player_list_index_191'), value: 1 },
    ]
    const levelOpts = [
      { gameLevelString: i18n.t('upgrade_page_views_player_list_index_192'), gameLevel: 0 },
    ]
    const priceOpts = [
      { text: i18n.t('upgrade_page_views_player_list_index_193'), value: 0 },
      { text: '1~50', value: '1_50' },
      { text: '51~100', value: '51_100' },
      { text: '100~200', value: '100_200' },
      { text: i18n.t('upgrade_page_views_player_list_index_194'), value: '200_99999' },
    ]
    return {
      isMobile,
      loading: false,
      initing: false,
      setting: false,
      list: [],
      pageIndex: 0,
      pageSize: 60,
      pageTotal: 0,
      nomore: false,
      sortOpts,
      filterSort: 0,
      sexOpts,
      filterSex: 0,
      levelOpts,
      filterLevel: 0,
      priceOpts,
      filterPrice: 0,
      quickSelectors: [],
      otherHighlight: false,
      popoverNormal: false,
      popoverOther: false,
      params: {},
      otherChoices: this.getDefaultParams(),
      selectRecord: [],
      sortArr: [i18n.t('upgrade_page_views_player_list_index_195'), i18n.t('upgrade_page_views_player_list_index_196'), i18n.t('upgrade_page_views_player_list_index_177'), i18n.t('upgrade_page_views_player_list_index_197'), i18n.t('upgrade_page_views_player_list_index_198'), i18n.t('upgrade_page_views_player_list_index_199'), i18n.t('upgrade_page_views_player_list_index_200'), i18n.t('upgrade_page_views_player_list_index_201')], // 按該標準排序
      hasDotShow: 0 // 陪陪曝光点标记
    }
  },
  computed: {
    ...mapGetters(['userInfo', 'accountInfo', 'myGames', 'allGames', 'quickOrderSkills']),
    reachBottom() {
      return this.$parent && this.$parent.reachBottom
    },
    routeFullPath() {
      return this.$route.fullPath
    },
    skillId() {
      return this.$route.params.skillId
    },
    allGamesFilter() {
      return Object.entries(this.allGames).reduce((prev, cuur) => {
        cuur[1].forEach(item => {
          if (!prev[item.id]) {
            prev[item.id] = item
          }
        })
        return prev
      }, {})
    },
    currentGame() {
      return this.allGamesFilter[this.skillId] || {}
    },
    currentGameCover() {
      const src = this.currentGame.imageUrl
      return src ? src + '?d=300x300' : ''
    },
    inMygames() {
      if (!this.currentGame.id) return true
      return this.myGames.some(item => {
        return item.id == this.skillId
      })
    },
    currentGameBanner() {
      return this.currentGame.bannerUrl
    },
    gameLevels() {
      let list = this.currentGame.gameLevelList
      if (!list || !list.length) return this.levelOpts
      list = list.slice().reverse()
      const len = list.length
      return [...this.levelOpts, ...(len < 12 ? list.slice(0, Math.floor(len / 2 + 1)) : list)]
    },
    // 篩選內的標籤列
    selectTags() {
      return this.$util.tagsList
    },
    sortedTags(){
      return this.sortArr.map(v => this.selectTags.find(vv => vv.label == v)).filter(v => v && v.label);
    },
    sortedTagsFront(){
      return this.sortedTags.filter(v=>this.sortArr.indexOf(v.label)<this.sortArr.indexOf(i18n.t('upgrade_page_views_player_list_index_196')));
    },
    sortedTagsEnd(){
      return this.sortedTags.filter(v=>this.sortArr.indexOf(v.label)>this.sortArr.indexOf(i18n.t('upgrade_page_views_player_list_index_177')));
    },
    // 是否展示上分必備
    carryTag() {
      if (!this.hasNewerCoupon && [1, 6].includes(this.currentGame.id)) {
        return {
          label: i18n.t('upgrade_page_views_player_list_index_197'),
          type: 'labels',
          value: 14,
        }
      }
      return ''
    },
    goodPosition() {
      const { gamePropertyList } = this.currentGame
      if (gamePropertyList) {
        const result = gamePropertyList.find(item => item.propertyCode === 'GoodPosition')
        if (result) return result.propertyValueList
      }
      return []
    },
    filterTag() {
      return this.otherChoices.labels || []
    },
    filterDiscount() {
      const tags = [];
      const { userInfo, accountInfo } = this
      if (userInfo && accountInfo.hasFirstOrderPrivilege) {
        tags.push({
          label: i18n.t('upgrade_page_views_player_list_index_196'),
          type: 'discount',
          value: 'firstOrderDiscount',
          checkbox: false,
        })
      }
      return tags.concat(this.quickSelectors.filter(item => item.type === 'discount'));
    },
    // 補充展示的標籤（回單王）
    specialTag() {
      return this.$util.tagsList.find(item => item.id === 10) || {}
    },
    // 有有效的新人体验券
    hasNewerCoupon() {
      const { accountInfo } = this
      return (accountInfo ? (accountInfo.couponInfoList || []) : []).some(item => {
        return item.couponTemplate === 'NEWCOMER_EXPERIENCE' && item.couponStatus === 'EFFECT'
      })
    },
    // 有有效的lol召回优惠券
    hasLolBackCounpon() {
      const { accountInfo } = this
      return (accountInfo ? (accountInfo.couponInfoList || []) : []).some(item => {
        return item.couponTemplate === 'REGRESS_LOL_COUPON' && item.couponStatus === 'EFFECT'
      })
    },
    // 显示一幣专区筛选项
    showOneCoin() {
      const { id } = this.currentGame
      if (!id) return false
      // 英雄联盟、传说对决、绝地求生、绝地求生M、特战英豪、好声音、语音交流、激鬥峽谷
      return this.hasNewerCoupon && [1, 6, 3, 5, 47, 39, 36, 125].includes(id)
    },
    // 显示极速约单按钮
    showQuickOrder() {
      return !!this.quickOrderSkills.find(item => item.id == this.skillId)
    },
    // 有打開的篩選
    popoverSome() {
      return this.popoverOther || this.popoverNormal
    },
  },
  watch: {
    accountInfo() {
      this.initSelectors()
    },
    currentGame() {
      this.initSelectors()
    },
    skillId(newId, oldId) {
      if (newId) {
        // 僅切換game
        console.log('watched id change, ', newId, oldId)
        this.initSelectors()
        this.initList()
        this.handleReset()
        this.handleSubmit()
      }
    },
    reachBottom(val) {
      if (val && !this.nomore) {
        // 滚动触底，自动加载下一页
        this.getData()
      }
    },
    popoverOther(val) {
      if (val) {
        // 打開其他篩選
        this.selectRecord = JSON.parse(JSON.stringify(this.otherChoices))
        if (this.isMobile) {
          this.popoverNormal = false
          this.$refs.selectNormal1.blur()
          this.$refs.selectNormal2.blur()
        }
      } else {
        if (!this.loading) {
          // 点击空白关闭其他篩選
          this.otherChoices = this.selectRecord
        }
      }
    },
    popoverSome(val) {
      if (val) {
        this.$parent.lockScroll = true
      } else {
        this.$parent.lockScroll = false
      }
    },
    routeFullPath() {
      this.closePopover()
    },
  },
  created() {
    if (!this.skillId) {
      this.$router.go(-1)
      return
    }
    this.initSelectors()
    if (!this.quickOrderSkills.length) {
      this.getQuickOrderSkills()
    }
  },
  mounted() {
    let mainDom = document.getElementById('page-main')
    this.skillDotFn = ()=>{
      this.skillShowDot(mainDom)
    }
    mainDom.addEventListener('scroll', this.skillDotFn)
  },
  beforeDestroy() {
    let mainDom = document.getElementById('page-main')
    mainDom.removeEventListener('scroll', this.skillDotFn)
  },
  methods: {
    ...mapActions('app', ['getQuickOrderSkills']),
     /**
     * @description: 陪陪曝光打点
     * @param {*}
     * @return {*}
     */
    skillShowDot(scrollDom) {
      if(!this.$refs.playerBox[0]) return
      const { scrollTop, clientHeight } = scrollDom
      const itemHeight = this.$refs.playerBox[0].clientHeight + 24
      if (!itemHeight) return
      
      const topHeight = scrollTop + clientHeight - this.$refs.listWrap.offsetTop
      const showIndex = parseInt(topHeight / itemHeight) * 5
      if (showIndex < 0 || showIndex < this.hasDotShow) return
      const oldIndex = this.hasDotShow || 0
      this.hasDotShow = showIndex
      this.list.slice(oldIndex, showIndex).forEach((item, index) => {
        if(!item.avatarImageUrl) return
        this.$adjust('skill_visited', {
          player_uuid: item.userUuid,
          skill_id: item.gameId,
          rank:  index + oldIndex
        })
      })
    },
    initSelectors() {
      const { /* userInfo, accountInfo,  */specialTag } = this
      let selectors = []
      if (this.showOneCoin) {
        // 優惠（value: 優惠傳參prop）
        selectors = [{
          label: i18n.t('upgrade_page_views_player_list_index_202'),
          type: 'discount',
          value: 'redBagFreeFlag',
          checkbox: false,
        }, {
          label: i18n.t('upgrade_page_views_player_list_index_203'),
          type: 'discount',
          value: 'recommendFlag',
          checkbox: false,
        }]
      // } else if (userInfo && accountInfo && accountInfo.hasFirstOrderPrivilege && !this.carryTag) {
      //   selectors = [{
      //     label: '首單優惠',
      //     type: 'discount',
      //     value: 'firstOrderDiscount',
      //     checkbox: false,
      //   }]
      } else if (specialTag.id) {
        // 特殊標籤（value: 標籤id）
        selectors = [{
          label: specialTag.label,
          type: 'labels',
          value: specialTag.id,
          checkbox: false,
        }]
      }
      if (!this.showOneCoin && this.carryTag) {
        selectors.push({ ...this.carryTag, checkbox: false })
      }
      // 擅長位置（value: 數組index）
      // let indexList = (this.hasNewerCoupon || this.carryTag) ? ['輔助'] : ['打野', '輔助']
      // indexList = indexList.map(item => {
      //   return this.goodPosition.findIndex(position => position === item)
      // }).filter(item => item !== -1)
      // if (indexList.length) {
      //   selectors.push(...indexList.map(i => ({
      //     label: this.goodPosition[i],
      //     type: 'positions',
      //     value: i,
      //     checkbox: false,
      //   })))
      // }
      if (this.skillId == 1 || this.skillId == 6) {
        selectors.push({
          label: i18n.t('upgrade_page_views_player_list_index_200'),
          type: 'labels',
          value: 15,
          checkbox: false,
        })
      }
      // 通用標籤補漏至3個（value: 標籤id）
      const moreNum = 3 - selectors.length
      if (moreNum > 0) {
        const tags = this.$util.tagsList.filter(item => item.id !== this.specialTag.id).slice(0, moreNum)
        selectors.push(...tags.map(item => ({
          label: item.label,
          type: 'labels',
          value: item.id,
          checkbox: false,
        })))
      } else if (moreNum < 0) {
        selectors.splice(3)
      }
      // 第4位固定本照認證
      selectors.push({
        label: i18n.t('upgrade_page_views_player_list_index_177'),
        type: 'faceSuccess',
        value: true,
        checkbox: false,
      })
      selectors.push({
        label: i18n.t('upgrade_page_views_player_list_index_201'),
        type: 'labels',
        value: 16,
        checkbox: false,
      })
      this.quickSelectors = selectors
      // 自動選擇某個技能類別（暫時只有自由市集）
      const { gameSubTypeId } = this.$route.query
      if (gameSubTypeId) {
        this.$set(this.otherChoices, 'gameSubTypeId', +gameSubTypeId)
      }
      // lol 召回用戶，自動選擇「回單王」標籤
      if (this.skillId == 1 && this.hasLolBackCounpon) {
        const id = this.specialTag.id
        const _labels = this.filterTag;
        _labels.push(id);
        this.$set(this.otherChoices, 'labels', _labels)
        const item = this.quickSelectors.filter(item => (item.type === 'labels' && item.value === id))[0]
        if (item) {
          item.checkbox = true
        }
      }
      this.handleSubmit()
    },
    initList() {
      this.hasDotShow = 0
      this.loading = false
      this.pageIndex = 0
      this.pageTotal = 0
      this.nomore = false
    },
    getData() {
      console.log('get data')
      return new Promise(resolve => {
        if (this.loading || !this.skillId) return
        this.loading = true
        const { pageIndex, pageSize, skillId, params } = this
        this.$http.post('/player/skill/list', {
          pageIndex,
          pageSize,
          gameId: skillId,
          autoFindGameColumn: true,
          ...params
        }).then(({ data }) => {
          const list = data.pageContent || []
          if (!this.pageTotal) {
            this.pageTotal = data.totalRemain
          }
          this.list = pageIndex == 0 ? list : this.list.concat(list)
          this.loading = false
          const len = list.length
          if (len == 0) {
            this.nomore = true
          } else if (len < pageSize) {
            this.nomore = true
            for (let i = 0; i < this.$util.addListItem(len, 5); i++) {
              this.list.push({
                id: -i
              })
            }
          } else {
            this.pageIndex++
          }
          resolve(data)
        }).catch(e => {
          resolve(e)
        })
      })
    },
    selectVisible(val, mIndex) {
      if (val) {
        this.popoverOther = false
      }
      if (val && mIndex) {
        const index = mIndex == 1 ? 2 : 1
        const target = this.$refs[`selectNormal${index}`]
        if (target) {
          target.blur()
        }
        this.$nextTick(() => {
          this.popoverNormal = val
        })
      }
      this.popoverNormal = val
    },
    closePopover() {
      if (!this.isMobile) return
      this.popoverNormal = false
      this.popoverOther = false
      this.$refs.selectNormal1.blur()
      this.$refs.selectNormal2.blur()
    },
    // 右側排序篩選
    selectSort(item) {
      if (this.loading) return
      const { value } = item // 判斷點了哪個item
      if (value < 3) {
        if (this.filterSort === value) return
        this.filterSort = value
      } else {
        // 價格高低切換
        const price = this.filterSort
        this.filterSort = price === 3 ? 4 : 3
        item.value = this.filterSort
      }
      this.handleSubmit()
    },
    quickSelect(item) {
      if (!this.quickSelectors.length) return
      this.selectOthers(item.type, item.value)
      this.handleSubmit()
    },
    selectOthers(type, value) {
      const list = this.otherChoices[type]
      if (Array.isArray(list)) {
        const i = list.findIndex(item => item === value)
        if (i + 1) {
          list.splice(i, 1)
        } else {
          list.push(value)
        }
      } else if (list === value) {
        this.$set(this.otherChoices, type, '')
      } else {
        this.$set(this.otherChoices, type, value)
      }
      if (this.filterTag.includes(14)) {
        this.filterLevel = 0
      }
    },
    handleReset() {
      this.filterSort = 0
      this.filterSex = 0
      this.filterLevel = 0
      this.filterPrice = 0
      this.otherHighlight = false
      this.params = {}
      this.otherChoices = this.getDefaultParams()
    },
    async handleSubmit(type) {
      this.popoverOther = false
      const { isMobile, filterSort, filterSex, filterLevel, filterPrice } = this
      if(filterLevel && this.filterTag.includes(14) && type==='level') {
        this.$set(this.otherChoices, 'labels', [])
      }
      const params = {
        sortType: ['Relevance', 'TransactionCountDesc', 'Newly', 'PriceAsc', 'PriceDesc'][filterSort], // 智能排序...
      }
      // 性别
      if (filterSex) {
        params.sex = ['Male', 'Female'][filterSex - 1]
      }
      if (!isMobile) {
        // 段位
        if (filterLevel) {
          params.gameLevelList = filterLevel
        }
        // 价格
        if (filterPrice) {
          params.salesPrice = filterPrice.split('_').map(item => +item)
        }
      }
      const { discount, faceSuccess, labels, positions, gameSubTypeId, salesPrice, gameLevelList } = this.otherChoices
      // 快捷篩選checkbox跟更多篩選保持一致
      for (const [key, val] of Object.entries(this.otherChoices)) {
        this.quickSelectors.forEach(item => {
          if (item.type === key) {
            item.checkbox = typeof val === 'object' ? val.includes(item.value) : val === item.value
          }
        })
      }
      // if (isMobile) {
        // 价格
        if (salesPrice) {
          params.salesPrice = salesPrice.split('_').map(item => +item)
        }
        // 段位
        if (gameLevelList.length) {
          params.gameLevelList = gameLevelList
        }
      // }
      // 優惠
      if (discount !== '') {
        params[discount] = 1
      }
      if (faceSuccess) {
        params.faceSuccess = true;
      }
      if (labels.length) {
        // 通用标签
        params.labels = this.filterTag
      }
      // 擅長位置
      if (positions.length) {
        params.goodPositionList = positions.map(i => this.goodPosition[i])
      }
      // 技能類別（暫時自由市集專屬）
      if (gameSubTypeId) {
        params.gameSubTypeId = gameSubTypeId
      }
      this.pageIndex = 0
      this.params = params
      this.initList()
      // 控制其他篩選項是否高亮
      let otherHighlight = false
      // eslint-disable-next-line no-unused-vars
      for (const [key, val] of Object.entries(this.otherChoices)) {
        if(key === 'labels'&&val===14) continue
        if(Array.isArray(val)&&val.length) {
          otherHighlight = true
          break
        }
        if(!Array.isArray(val)&&val) {
          otherHighlight = true
          break
        }
      }
      this.otherHighlight = otherHighlight
      await this.getData()
      this.$adjust('web_player_skill_list_request', {...params})
      setTimeout(()=>{
        this.skillShowDot(document.getElementById('page-main'))
      }, 500)
    },
    getDefaultParams() {
      return {
        salesPrice: '', // 价格区间
        discount: '', // 0满赠優惠 1首单優惠 2一幣專區 3優質推薦
        labels: [], // 标签
        gameLevelList: [], // 段位
        gameSubTypeId: '', // 自由市集
        positions: [], // 擅長位置
        faceSuccess: false,
      }
    },
    setMygames() {
      if (this.myGames.length > 9) {
        this.$message.warning(i18n.t('upgrade_page_views_player_list_index_204'))
        return
      }
      if (this.setting) return
      this.setting = true
      this.$http.post('/game/userCustom/save', {
        gameIds: [...this.myGames.map(item => {
          return item.id
        }), this.skillId]
      }).then(({ code }) => {
        if (code == 200) {
          this.$store.dispatch('app/getGamesList').then(() => {
            this.$message.success(i18n.t('upgrade_page_views_player_list_index_205'))
            this.setting = false
          })
        } else {
          this.setting = false
        }
      })
    },
    toQuickOrder() {
      window.sessionStorage.setItem('initSkillId4QuickOrderCreate', this.skillId)
      this.$nextTick(() => {
        this.$router.push('/quick-order')
      })
    },
    selectSex(val) {
      if (this.filterSex == val) {
        this.filterSex = 0;
      } else {
        this.filterSex = val;
      }
    },
  }
}
</script>

<style lang="scss">
  .filter-other-popover {
    padding: 0 16px;
    border: none;
    .filter-box {
      overflow-x: hidden;
      // overflow-y: scroll;
      scroll-behavior: smooth;
      padding: 16px 0;
      // max-height: 400px;
    }
    .title {
      color: $color-gray-2;
      font-size: 13px;
      line-height: 18px;
      // margin-top: 10px;
      text-align: left;
    }
    ul {
      @include flex(flex-start);
      flex-wrap: wrap;
      padding-bottom: 5px;
      margin: 0 -5px;
      li {
        @include flex;
        margin: 5px;
        width: 78px;
        height: 32px;
        background: $color-button;
        border-radius: 7.2px;
        color: $color-gray-2;
        font-size: 13px;
        cursor: pointer;
        &.active {
          color: #fff;
          background: $color-gray-2;
        }
      }
    }
    .game-type {
      padding-top: 0;
      li {
        margin-top: 10px;
      }
    }
    .buttons {
      @include flex(space-between);
      border-top: 1PX solid $color-button;
      padding: 15px 0;
      font-size: 16px;
      div {
        flex-grow: 1;
        @include flex;
        width: 166px;
        height: 44px;
        border-radius: 50px;
        cursor: pointer;
      }
      .reset {
        border: 1px solid #DDDFE5;
        color: $color-gray-2;
      }
      .submit {
        margin-left: 11px;
        color: $color-gray-1;
        // font-weight: 500;
        background: $color-yellow;
      }
    }
  }
  @media screen and (max-width: 599px) {
    .filter-other-popover, .el-select-dropdown {
      left: 0!important;
      width: 100vw!important;
      margin-top: 0!important;
      .popper__arrow {
        display: none;
      }
    }
    .playerlist-mobile-select {
      .el-select .el-input__inner, .select-other {
        border: 0!important;
        padding-left: 20px;
        text-align: center!important;
      }
    }
    .playerlist-mobile-popover {
      border: 0!important;
      border-radius: 0!important;
      box-shadow: none!important;
    }
  }
</style>

<style lang="scss" scoped>
  .game-info {
    padding: 16px 0 0;
    .banner {
      @include flex(space-between);
      position: relative;
      overflow: hidden;
      padding: 28px;
      background-size: cover;
      border-radius: 8px;
      &::before {
        content: '';
        position: absolute;
        z-index: 0;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(266.91deg, rgba(0, 0, 0, 0.43) 22.26%, rgba(0, 0, 0, 0.15) 106.95%);
      }
    }
    .banner-small{
      padding: 0px;
      &::before {
        display: none;
      }
      .cover{ 
        img{
          width: 48px;
          height: 48px;
        }
        .name{
          color: #000;
          font-size: 24px;
        }
      }
    }
    .cover {
      @include flex;
      position: relative;
      z-index: 1;
      img {
        width: 104px;
        height: 104px;
        border-radius: 8px;
        box-shadow: 0px 1.48571px 5.94286px rgba(78, 78, 78, 0.34);
      }
      .name {
        margin-left: 19px;
        line-height: 48px;
        color: #fff;
        font-size: 32px;
        font-weight: 600;
      }
    }
    .handle {
      @include flex;
      position: relative;
      z-index: 1;
      cursor: pointer;
      > div {
        @include flex;
        min-width: 136px;
        height: 40px;
        padding: 0 16px;
        font-size: 14px;
        font-weight: 500;
        border-radius: 20px;
        + div {
          margin-left: 14px;
        }
      }
      .myskill {
        border: 2px solid #fff;
        color: #fff;
        &:hover {
          background: rgba($color: #fff, $alpha: 0.15)
        }
        i {
          margin-right: 3px;
          font-size: 16px;
        }
      }
      .quickorder {
        @include button-yellow;
      }
      .btn-gray{
        @include button-gray-2;
      }
    }
  }
  .select-wrap {
    @include flex(flex-start);
    margin-top: 24px;
    > * {
      width: 132px;
      margin-right: 8px;
    }
    .select-other {
      @include flex(flex-start);
      position: relative;
      width: 132px;
      height: 44px;
      font-size: 0;
      padding: 0 30px 0 15px;
      border: 1px solid $color-split;
      background-color: #fff;
      border-radius: 4px;
      cursor: pointer;
      > span {
        color: $color-gray-2;;
        font-size: 14px;
      }
      .suffix {
        @include flex;
        position: absolute;
        right: 5px;
        top: 0;
        width: 25px;
        height: 100%;
        color: #C0C4CC;
        font-size: 14px;
        i {
          transform: rotate(180deg);
          transition: transform .3s,-webkit-transform .3s;
        }
      }
      &:hover, &.active {
        border-color: $color-gray-4;
      }
      &.active .suffix i {
        transform: rotate(0);
      }
      &.high-light {
        border-color: $color-orange;
        > span, .suffix {
          color: $color-orange;
        }
      }
    }
    .select-orders {
      flex-grow: 1;
      @include flex(flex-end);
      margin-right: 0;
      ul {
        @include flex;
        li {
          @include flex;
          box-sizing: content-box;
          width: 76px;
          height: 42px;
          color: $color-gray-3;
          font-size: 14px;
          border: 1px solid rgba(140, 148, 170, 0.3);
          cursor: pointer;
          &:first-child {
            border-top-left-radius: 6px;
            border-bottom-left-radius: 6px;
          }
          &:last-child {
            border-top-right-radius: 6px;
            border-bottom-right-radius: 6px;
          }
          &:not(:first-child) {
            border-left: none;
          }
          .fps-icon {
            color: #C5C9D4;
            font-size: 13px;
            margin-left: 2px;
          }
          span {
            @include flex(center, center, column);
            margin: 0 0 0 4px;
            &::before {
              content: '';
              @include triangle(6px, #C5C9D4, top);
              margin-bottom: 2px;
            }
            &::after {
              content: '';
              @include triangle(6px, #C5C9D4);
            }
          }
          &.active {
            color: #fff;
            background-color: $color-gray-2;
            .fps-icon {
              color: #fff;
            }
          }
          &.up span {
            &::before {
              @include triangle(6px, #fff, top);
            }
            &::after {
              @include triangle(6px, $color-gray-3);
            }
          }
          &.down span {
            &::before {
              @include triangle(6px, $color-gray-3, top);
            }
            &::after {
              @include triangle(6px, #fff);
            }
          }
        }
      }
    }
  }
  .filter-quick {
    width: 100%;
    // margin-top: 20px;
    flex-grow: 2;
    ul {
      @include flex(flex-start);
      li {
        flex-shrink: 0;
        white-space: nowrap;
        + li {
          margin-left: 8px;
        }
      }
    }
  }
  .list-wrap {
    @include flex(space-between, flex-start);
    flex-wrap: wrap;
    position: relative;
    padding: 12px 0 60px;
    > * {
      width: 207px;
      margin-top: 24px;
    }
  }
  .empty {
    position: relative;
    margin: 42px auto 0;
    img {
      display: block;
      width: 108px;
      margin: 0 auto;
    }
    p {
      margin-top: 20px;
      text-align: center;
      color: $color-gray-3;
      font-size: 14px;
    }
  }

  @media screen and (max-width: 599px) {
    .page-wrap {
      @include flex(flex-start, stretch, column);
      flex-wrap: wrap;
    }
    .game-info {
      width: 100%;
      padding: 0;
      .banner {
        padding: 18px;
        border-radius: 0;
      }
      .cover {
        img {
          width: 52px;
          height: 52px;
        }
        .name {
          font-size: 24px;
          font-weight: 500;
        }
      }
      .handle {
        display: none;
      }
    }
    .select-wrap {
      @include flex(center);
      width: 100%;
      margin-top: 0;
      border-bottom: 1px solid $color-split;
      background-color: #fff;
      > * {
        margin-right: 0;
        width: 116px;
      }
      .select-other {
        width: 116px;
        padding-left: 20px;
        span {
          flex-grow: 1;
          text-align: center;
        }
      }
    }
    .filter-quick {
      width: 100%;
      padding: 0 16px;
      margin-top: 12px;
      ul {
        @include flex(flex-start);
        li {
          min-width: 80px;
          background-color: #fff;
          & + li {
            margin-left: 10px;
          }
        }
      }
    }
    .list-wrap, .empty {
      width: 100%;
      .popover {
        position: absolute;
        z-index: 10;
        left: 0;
        top: 0;
        width: 0;
        height: 0;
        background-color: #000;
        opacity: 0;
        transition: opacity 0.2s 0.1s;
      }
      &.popover-wrap .popover {
        opacity: 0.6;
        width: 100%;
        height: 100%;
      }
    }
    .list-wrap {
      padding: 12px 12px 30px;
      > * {
        flex-grow: 1;
        width: 40%;
        margin: 7px 4px;
      }
    }
    .empty {
      flex-grow: 1;
      margin: 0;
      padding: 42px 0 0;
    }
  }

.el-select-dropdown {
  .el-select-dropdown__list {
    padding: 8px;
    .el-select-dropdown__item {
      color: $color-gray-2;
    }
  }
}
</style>
<style lang="scss">
.select-wrap .el-input__inner {
  color: $color-gray-2;
}
</style>
